export default __webpack_public_path__ + "static/logo-649f64d0c20b1e95d1506dac6a0526ce.png";